import React from 'react';
import { Box, Card, CardContent, CardMedia, Typography, Button, Grid, useTheme, useMediaQuery } from '@mui/material';
import Portfolio from '../../images/Portfolio.png';
import Java from '../../images/JavaSwing.png';
import ThingsToDo from '../../images/ThingsToDo.png';
import TicTacToeImage from '../../images/TicTacToe.png';
import JobHunter from '../../images/JobHunter.png';
import Chatbot from '../../images/chatbot.png'; 

import { useNavigate } from 'react-router-dom'; 

const projects = [
  {
    title: "JobHunter AI (Agentic LLM Platform)",
    image: JobHunter,
    githubUrl: "https://github.com/Anand200399/Job-Hunter",
    liveDemoUrl: "https://jobs.anandpandey.me/login",
    description: "A self-built agentic platform powered by the Anthropic Claude API that scores candidate-job fit (60–97) with structured reasoning across three tiers. Built end-to-end: prompt engineering, JSON schema validation, fallback handling, and a 2-hour TTL caching layer to optimize API spend.",
    isGame: false
  },
  {
    title: "PortfolioBot (Agentic AI Assistant)",
    image: Chatbot,
    githubUrl: "https://github.com/Anand200399/portfoliobot-backend",
    liveDemoUrl: "https://www.anandpandey.me",
    description: "The agentic chatbot you see in the bottom-right of this site. Built with Groq's Llama 3.3 using a custom tool-calling loop — the LLM autonomously picks which tool to call per question (get_about, get_projects, get_contact, etc.) and synthesizes the answer from the knowledge base.",
    isGame: false
  },
  {
    title: "Portfolio(Web Design)",
    image: Portfolio,
    githubUrl: "https://github.com/Anand200399/Anand-Pandey-Portfolio.git",
    liveDemoUrl: "https://portfolio-hn7u.onrender.com/",
    description: "A compilation of web design projects that exhibit a diverse range of contemporary web design principles and technologies, such as responsive layouts, interactive UI components, CSS animations, implemented using React, Material UI, and JavaScript.",
    isGame: false
  },
  {
    title: "Online Shopping (Java Swing)",
    image: Java,
    githubUrl: "https://github.com/Anand200399/AED-FINAL-PROJECT.git",
    liveDemoUrl: "https://github.com/Anand200399/AED-FINAL-PROJECT.git",
    description: "This project is a Java Swing application designed to simulate an online shopping experience. Developed with object-oriented programming and event-driven concepts.",
    isGame: false
  },
  {
    title: "ThingsToDo (Event Management)",
    image: ThingsToDo,
    githubUrl: "https://github.com/ShubhamLakhotia-ui/ThingsTODO.git",
    liveDemoUrl: "https://main.d32wc4ofeanrvp.amplifyapp.com/login",
    description: "An event management system to help users organize and track their events with features like event registration, attendee management, and notifications.",
    isGame: false
  },
  {
    title: "Tic Tac Toe (Game)",
    image: TicTacToeImage,
    description: "A classic two-player Tic Tac Toe game built with React and styled using Material UI. Enjoy a simple yet engaging gaming experience.",
    isGame: true  // <-- Mark this project as a game
  }
];

const ProjectsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const cardHeight = isMobile ? 300 : 340;
  const navigate = useNavigate();  // <-- for internal navigation

  return (
    <Box sx={{ flexGrow: 1, padding: 4, backgroundColor: 'white' }}>
      <Typography variant="h4" component="div" gutterBottom sx={{
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: isMobile ? '30px' : '40px',
        color: 'black',
        marginBottom: '3%'
      }}>
        Browse My <span style={{ color: '#f9004d' }}>Projects</span>
      </Typography>
      <Grid container spacing={4}>
        {projects.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
              }
            }}>
              <CardMedia
                component="img"
                sx={{ height: cardHeight, width: '100%', objectFit: 'cover' }}
                image={project.image}
                alt={project.title}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="div" gutterBottom>
                  {project.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {project.description}
                </Typography>
                <Box>
                  {!project.isGame ? (
                    <>
                      <Button 
                        sx={{ margin: 1,
                          backgroundColor: 'transparent',
                          color: 'black',
                          border: '1px solid #f9004d',
                          fontSize: isMobile ? '12px' : '15px',
                          '&:hover': {
                            backgroundColor: 'transparent',
                            color: '#f9004d',
                            border: '1px solid black'
                        } }}
                        onClick={() => window.open(project.githubUrl, "_blank")}
                      >
                        Github
                      </Button>
                      <Button
                        sx={{ margin: 1,
                          backgroundColor: 'transparent',
                          color: 'black',
                          border: '1px solid #f9004d',
                          fontSize: isMobile ? '12px' : '15px',
                          '&:hover': {
                            backgroundColor: 'transparent',
                            color: '#f9004d',
                            border: '1px solid black'
                        } }}
                        onClick={() => window.open(project.liveDemoUrl, "_blank")}
                      >
                        Live Demo
                      </Button>
                    </>
                  ) : (
                    <Button
                      sx={{ margin: 1,
                        backgroundColor: 'transparent',
                        color: 'black',
                        border: '1px solid #f9004d',
                        fontSize: isMobile ? '12px' : '15px',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: '#f9004d',
                          border: '1px solid black'
                      } }}
                      onClick={() => navigate('/tictactoe')}
                    >
                      Play
                    </Button>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProjectsSection;
